import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { usePlans } from "../../../RegularPlan/PlansContext";

const localeRoot = "pricing_plans.plan_settings.plan_summary";

export const PlanTitle = () => {
  const { selectedPlan } = usePlans();
  if (!selectedPlan) return null;

  return (
    <div className="flex justify-between">
      <Typography.LabelSm weight="semibold">
        {t([localeRoot, "plan_name"], { plan: selectedPlan.display_name })}
      </Typography.LabelSm>
      <Typography.LabelSm weight="semibold">
        {selectedPlan.annual_base_amount_with_currency}
      </Typography.LabelSm>
    </div>
  );
};
